import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Assignment, Group } from '../models';

export interface GastroMasterRequest {
  can_use_outside: boolean;
  price1_code: string;
  valid_from: string;
  valid_to: string;
  first_name: string;
  last_name: string;
  initial_balance: number;
  allowed_overdraft: number;
}

export interface GastroMasterResponse {
  message: string;
  success: boolean;
}

/**
 * Service for credit-related API calls
 */
@Injectable({
  providedIn: 'root'
})
export class GastroService {
  constructor(private apiService: ApiService) {}

  /**
   * Submit credit assignments to Gastro
   * POST /api/v2/Credit/submit
   */
  createMasterCard(
    masterId: string,
    request: GastroMasterRequest
  ): Observable<GastroMasterResponse> {
    return this.apiService.post<GastroMasterResponse>(
      `/api/v1/Gastro/create-master/${masterId}`,
      request
    );
  }

  createAdditionalCard(
    masterCardNumber: string,
    additionalCardNumber: string
  ): Observable<GastroMasterResponse> {
    console.log("Additional : ",masterCardNumber,additionalCardNumber);
    return this.apiService.post<GastroMasterResponse>(
      `/api/v1/Gastro/create-additional/${masterCardNumber}/${additionalCardNumber}`,
      {}
    );
  }

  /**
   * Delete master card from Gastro
   * DELETE /api/v1/Gastro/delete-master/{cardNumber}
   */
  deleteMasterCard(
    cardNumber: string
  ): Observable<GastroMasterResponse> {
    return this.apiService.delete<GastroMasterResponse>(
      `/api/v1/Gastro/delete-master/${cardNumber}`
    );
  }

  /**
   * Delete additional card from Gastro
   * DELETE /api/v1/Gastro/delete-additional/{masterCardNumber}/{additionalCardNumber}
   */
  deleteAdditionalCard(
    masterCardNumber: string,
    additionalCardNumber: string
  ): Observable<GastroMasterResponse> {
    console.log('Deleting additional card:', masterCardNumber, additionalCardNumber);
    const url = `/api/v1/Gastro/delete-additional/${masterCardNumber}/${additionalCardNumber}`;
    console.log('URL:', url);
    return this.apiService.delete<GastroMasterResponse>(url);
  }

  //helper
  /**
   * Calculate total credit (budget + overdraft) for groups
   */
  calculateTotalCredit(groups: Group[]): number {
    return this.calculateTotalBudget(groups) + this.calculateTotalOverdraft(groups);
  }

  /**
   * Calculate total budget for groups
   */
  calculateTotalBudget(groups: Group[]): number {
    return groups.reduce((total, group) => total + group.price, 0);
  }

  /**
   * Calculate total overdraft for groups
   */
  calculateTotalOverdraft(groups: Group[]): number {
    return groups.reduce((total, group) => total + group.overdraft, 0);
  }
}
